import { createContext, createElement, useContext, useMemo } from 'react';

const fr = {
  home: 'Accueil',
  browse: 'Parcourir',
  cart: 'Panier',
  deals: 'Offres',
  saved: 'Enregistrés',
  account: 'Compte',
  signIn: 'Connexion',
  logoAria: 'Marketplace Taaouniaty',
  searchPlaceholder: 'Que cherchez-vous aujourd’hui ?',
  searchAria: 'Rechercher sur le marketplace',
  homeSearchPlaceholder: 'Coopérative, catégorie ou produit…',
  homeSearchAria: 'Rechercher une coopérative, une catégorie ou un produit',
  kindCategory: 'Catégorie',
  kindCoop: 'Coopérative',
  kindProduct: 'Produit',
  ticker:
    'Livraison partout au Maroc  ·  Paiement à la livraison  ·  Produits authentiques de coopératives marocaines  ·  ',
  featured: 'À la une',
  soldOut: 'Épuisé',
  soldOutCart: 'Un produit de votre panier est épuisé. Retirez-le pour commander.',
  freeDelivery: 'Livraison offerte',
  save: 'Enregistrer',
  unsave: 'Retirer des enregistrés',
  savedLabel: 'Enregistré',
  percentOff: (n) => `${n}% off`,
  prevAria: (title) => `Précédent : ${title}`,
  nextAria: (title) => `Voir plus : ${title}`,
  ofTheMoment: 'Offre du moment',
  featuredRail: 'En vedette',
  followedRail: 'Vos coopératives',
  followToastTitle: (name) => `Vous suivez ${name}`,
  followToastTitleGeneric: 'Boutique suivie',
  followToastText: 'Vous recevrez un e-mail à chaque nouveau produit.',
  atCoop: (name) => `Chez ${name}`,
  spotlightStory: (title, coop) => `Derrière ${title}, le savoir-faire de ${coop}.`,
  networkKicker: 'Le réseau Taaouniaty',
  networkTitle: 'Des visages, des histoires',
  networkTitleAccent: ' du réseau Taaouniaty.',
  networkText:
    'Rencontrez les femmes et les hommes des coopératives du réseau Taaouniaty. Chaque atelier a une histoire. En achetant ici, vous les soutenez directement, partout au Maroc.',
  networkCta: 'Découvrir les coopératives',
  portraits: 'Portraits',
  ateliers: 'Ateliers',
  together: 'Ensemble',
  footLine1: 'Le marketplace du réseau Taaouniaty.',
  footLine2: 'Des coopératives réelles, partout au Maroc.',
  qrTitle: 'Scanner pour ouvrir le marketplace',
  discover: 'Découvrir',
  sell: 'Vendre',
  social: 'Social',
  brandCol: 'Taaouniaty',
  joinNetwork: 'Rejoindre le réseau',
  createShop: 'Créer une boutique',
  theSite: 'Le site',
  portraitsLink: 'Portraits',
  cooperatives: 'Coopératives',
  blog: 'Blog',
  marketplace: 'Marketplace',
  poweredBy: 'Propulsé par',
  homeSeoTitle: 'Marketplace des coopératives marocaines | Acheter en ligne | Taaouniaty',
  homeSeoDesc:
    'Marketplace des coopératives marocaines : commandez en ligne artisanat, coffrets et produits du terroir. Livraison partout au Maroc, paiement à la livraison.',
  homeHeadline: 'Marketplace des coopératives marocaines',
  homePitch:
    'Achetez en ligne auprès des coopératives — panier, livraison au Maroc, paiement à la livraison. Pas seulement un contact WhatsApp.',
  homeWhyTitle: 'Pourquoi Taaouniaty',
  homeWhyBuy: 'Commande en ligne',
  homeWhyShip: 'Livraison partout au Maroc',
  homeWhyPay: 'Paiement à la livraison',
  homeFaqTitle: 'Questions fréquentes',
  homeFaq: [
    {
      q: 'C’est quoi le marketplace des coopératives Taaouniaty ?',
      a: 'Une boutique en ligne : vous parcourez les produits des coopératives marocaines, vous commandez, et vous payez à la livraison.',
    },
    {
      q: 'Puis-je commander en ligne, pas seulement via WhatsApp ?',
      a: 'Oui. Taaouniaty est une boutique : panier, commande, livraison partout au Maroc et paiement à la livraison.',
    },
  ],
  savedSeoTitle: 'Enregistrés — marketplace taaouniaty',
  savedEmpty: 'Aucun produit enregistré pour le moment.',
  browseProducts: 'Parcourir les produits',
  allProducts: 'Tous les produits',
  sort: 'Trier',
  sortNew: 'Nouveautés',
  sortBest: 'Meilleures ventes',
  sortPriceAsc: 'Prix croissant',
  sortPriceDesc: 'Prix décroissant',
  all: 'Tous',
  others: 'Autres',
  emptyProducts: 'Aucun produit ici pour le moment.',
  coopPrompt: 'Envie de connaître les coopératives derrière ces produits ?',
  coopPromptLink: 'Découvrez nos coopératives partenaires →',
  categoryBlurb: (name) =>
    `Nos ${String(name || '').toLowerCase()}, confectionnés à la main par des coopératives marocaines. Livraison partout au Maroc.`,
  browseTitle: (name) => `${name} des coopératives marocaines | Acheter en ligne | Taaouniaty`,
  dealsSeoTitle: 'Offres — marketplace taaouniaty',
  dealsSeoTitleCat: (name) => `Offres ${name} — taaouniaty`,
  dealsSeoDesc: 'Produits en promotion sur le marketplace taaouniaty. Livraison partout au Maroc.',
  dealsSeoDescCat: (name) => `Les offres en cours dans ${name}, par des coopératives marocaines.`,
  dealsBlurb: (name) =>
    `Les offres en cours dans ${String(name || '').toLowerCase()}, confectionnées par des coopératives marocaines.`,
  dealsEmpty: 'Aucune offre ici pour le moment.',
  allDeals: 'Toutes les offres',
  notFound: 'Produit introuvable.',
  loading: 'Chargement…',
  client: 'Client',
  reviewsCount: (n) => `${n} avis`,
  deliveryEverywhere: 'Livraison partout au Maroc',
  moreOptions: 'Plus d’options',
  contactOwner: (name) => `Contacter ${name}`,
  reportProduct: 'Signaler le produit',
  contactHint: 'Laissez vos coordonnées. L’équipe taaouniaty vous répondra.',
  contactOrCall: 'Ou appelez l’équipe taaouniaty',
  messageLabel: 'Message',
  sendMessage: 'Envoyer',
  contactSent: 'Message envoyé. Merci.',
  reportHint: 'Dites-nous ce qui ne va pas avec ce produit.',
  reportSent: 'Signalement envoyé. Merci.',
  ticketFail: 'Impossible d’envoyer. Réessayez.',
  qty: 'Quantité',
  minus: 'Moins',
  plus: 'Plus',
  addToCart: 'Ajouter au panier',
  buy: 'Acheter',
  share: 'Partager',
  description: 'Description',
  descFallback: (title, brand) =>
    `${title} est proposé par ${brand} sur le marketplace taaouniaty. Livraison partout au Maroc, paiement à la livraison.`,
  seoProductDesc: (title, brand) =>
    `Achetez ${title} chez ${brand} sur le marketplace taaouniaty. Livraison partout au Maroc.`,
  moreDetails: (name) => `Plus de détails chez ${name}`,
  alsoLike: 'Vous aimerez aussi',
  shippingReturns: 'Livraison et retours',
  shippingReturnsText:
    'Livraison partout au Maroc. Paiement à la livraison. Vous pouvez nous écrire pour un retour ou un échange.',
  coopOwnerBadge: 'Coopérative',
  coopOwnerFollow: 'Suivre',
  coopOwnerVisit: (name) => `Voir la boutique ${name}`,
  coopOwnerNew: 'Nouveau',
  coopShopProducts: 'Produits',
  coopShopSearch: (name) => `Rechercher ${name}…`,
  coopShopSort: 'Trier',
  coopShopOnSale: 'En promo',
  coopShopPrice: 'Prix',
  coopShopInStock: 'En stock',
  coopShopFollow: 'Suivre',
  coopShopFollowing: 'Suivi',
  coopShopFollowNeedAccount: 'Créez un compte pour suivre cette boutique.',
  coopShopFilters: 'Filtres',
  coopShopReset: 'Réinitialiser',
  coopShopDone: 'Terminé',
  coopShopMenu: 'Menu',
  coopShopPortrait: 'Portrait',
  coopShopPriceAny: 'Tous les prix',
  coopShopPriceLow: 'Moins de 100 MAD',
  coopShopPriceMid: '100 – 250 MAD',
  coopShopPriceHigh: 'Plus de 250 MAD',
  coopShopSeoDesc: (name) =>
    `Achetez en ligne les produits de ${name}, coopérative marocaine. Livraison partout au Maroc, paiement à la livraison.`,
  coopShopMissing: 'Cette coopérative n’a pas encore de boutique ici.',
  coopCardReviews: 'Avis',
  coopCardRatings: (n) => (n > 1 ? `${n} notes` : `${n} note`),
  coopCardContact: 'Contact',
  coopCardCertificates: 'Certificats',
  coopCardReport: 'Signaler la boutique',
  coopCardReportHint: 'Dites-nous ce qui ne va pas avec cette coopérative.',
  coopCardNoReviews: 'Aucun avis pour le moment.',
  coopCardNoContact: 'Coordonnées non publiées.',
  coopCardNoCerts: 'Aucun certificat publié.',
  coopCardAddress: 'Adresse',
  coopCardWhatsapp: 'WhatsApp',
  coopCardVisit: 'Voir le catalogue',
  coopCardCopied: 'Copié',
  coopCardInstagram: 'Instagram',
  coopCardFacebook: 'Facebook',
  noReviews: 'Aucun avis publié pour le moment.',
  prevReview: 'Avis précédent',
  nextReview: 'Avis suivant',
  prevPhoto: 'Média précédent',
  nextPhoto: 'Média suivant',
  galleryPhoto: 'Photo',
  galleryVideo: 'Vidéo',
  cartSeoTitle: 'Panier — marketplace taaouniaty',
  cartSeoDesc: 'Votre panier sur le marketplace taaouniaty.',
  articles: (n) => (n > 1 ? `${n} articles` : `${n} article`),
  emptyCart: 'Votre panier est vide.',
  remove: 'Retirer',
  summary: 'Récapitulatif',
  subtotal: 'Sous-total',
  delivery: 'Livraison',
  toConfirm: 'À confirmer',
  deliveryFree: 'Gratuite',
  total: 'Total',
  trustLine: 'Livraison partout au Maroc · Paiement à la livraison',
  name: 'Nom',
  phone: 'Téléphone',
  city: 'Ville',
  cityPlaceholder: 'Ex. Casablanca',
  address: 'Adresse',
  addressPlaceholder: 'Quartier, rue, n°…',
  noteOptional: 'Note (optionnel)',
  locate: 'Obtenir ma localisation',
  locating: 'Recherche…',
  locateHint: 'Remplit la ville et l’adresse automatiquement.',
  sending: 'Envoi…',
  order: 'Commander',
  locNoGeo: 'Votre navigateur ne peut pas donner la localisation. Remplissez la ville et l’adresse à la main.',
  locFail: 'Impossible de trouver l’adresse. Remplissez la ville et l’adresse à la main.',
  locDenied: 'Localisation refusée. Remplissez la ville et l’adresse à la main.',
  orderFail: 'La commande n’a pas pu être envoyée. Vérifiez vos informations et réessayez.',
  orderDoneSeo: 'Commande envoyée — taaouniaty',
  orderDoneTitle: 'Votre commande a été enregistrée !',
  orderDoneText: (name) =>
    `Merci${name ? `, ${name}` : ''}. Nous vous appellerons pour confirmer la livraison et le paiement à la livraison.`,
  viewReceipt: 'Voir reçu',
  back: 'Retourner',
  yourSpace: 'Votre espace',
  accountLead: 'Connectez-vous pour voir vos commandes, reçus et collections.',
  accountLeadFollow: 'Créez un compte pour suivre cette coopérative. Vous recevrez un e-mail à chaque nouveau produit.',
  createAccount: 'Créer un compte',
  email: 'E-mail',
  password: 'Mot de passe',
  createMyAccount: 'Créer mon compte',
  loginAction: 'Se connecter',
  loginFail: 'Connexion impossible.',
  hello: 'Bonjour',
  logout: 'Déconnexion',
  overview: 'Aperçu',
  followed: 'Suivies',
  noFollowed: 'Aucune boutique suivie pour le moment.',
  orders: 'Commandes',
  receipts: 'Reçus',
  collections: 'Collections',
  noOrders: 'Aucune commande pour le moment.',
  noReceipts: 'Aucun reçu pour le moment.',
  noSaved: 'Aucun produit enregistré.',
  viewReceiptLink: 'Voir le reçu',
  receiptLabel: (ref) => `Reçu ${ref}`,
  accountSeoLogin: 'Connexion — marketplace taaouniaty',
  accountSeoMe: 'Mon espace — marketplace taaouniaty',
  reviewed: 'a laissé un avis',
  ordered: 'a acheté',
  close: 'Fermer',
  addCollection: '+ Ajouter une collection',
  collectionName: 'Nom de la collection',
  create: 'Créer',
  collectionCreated: 'Collection créée',
  collectionFail: 'Impossible de créer la collection.',
  switchLang: 'Passer en arabe',
  switchLangAr: 'Passer en français',
  langLabel: 'العربية',
  langLabelFr: 'Français',
  dateLocale: 'fr-FR',
};

const ar = {
  home: 'الرئيسية',
  browse: 'تصفح',
  cart: 'السلة',
  deals: 'عروض',
  saved: 'المحفوظات',
  account: 'حساب',
  signIn: 'دخول',
  logoAria: 'سوق تعاونيتي',
  searchPlaceholder: 'ماذا تبحثون اليوم؟',
  searchAria: 'البحث في السوق',
  homeSearchPlaceholder: 'تعاونية أو فئة أو منتج…',
  homeSearchAria: 'ابحث عن تعاونية أو فئة أو منتج',
  kindCategory: 'فئة',
  kindCoop: 'تعاونية',
  kindProduct: 'منتج',
  ticker: 'التوصيل في كل المغرب  ·  الدفع عند الاستلام  ·  منتجات أصيلة من التعاونيات المغربية  ·  ',
  featured: 'مميز',
  soldOut: 'نفد المخزون',
  soldOutCart: 'أحد منتجات سلتكم نفد. أزيلوه لإتمام الطلب.',
  freeDelivery: 'توصيل مجاني',
  save: 'حفظ',
  unsave: 'إزالة من المحفوظات',
  savedLabel: 'محفوظ',
  percentOff: (n) => `${n}٪ خصم`,
  prevAria: (title) => `السابق: ${title}`,
  nextAria: (title) => `المزيد: ${title}`,
  ofTheMoment: 'عرض اليوم',
  featuredRail: 'مختارات',
  followedRail: 'تعاونياتكم',
  followToastTitle: (name) => `تتم متابعة ${name}`,
  followToastTitleGeneric: 'تتم متابعة المتجر',
  followToastText: 'ستصلكم رسالة عند كل منتج جديد.',
  atCoop: (name) => `لدى ${name}`,
  spotlightStory: (title, coop) => `خلف ${title}، خبرة ${coop}.`,
  networkKicker: 'شبكة تعاونيتي',
  networkTitle: 'وجوه وقصص',
  networkTitleAccent: ' من شبكة تعاونيتي.',
  networkText:
    'تعرّفوا على نساء ورجال تعاونيات شبكة تعاونيتي. لكل ورشة قصة. بالشراء هنا تدعمونهم مباشرة، في كل المغرب.',
  networkCta: 'اكتشفوا التعاونيات',
  portraits: 'صور',
  ateliers: 'ورشات',
  together: 'معاً',
  footLine1: 'سوق شبكة تعاونيتي.',
  footLine2: 'تعاونيات حقيقية، في كل المغرب.',
  qrTitle: 'امسح لفتح السوق',
  discover: 'اكتشف',
  sell: 'بيع',
  social: 'تواصل',
  brandCol: 'تعاونيتي',
  joinNetwork: 'انضموا إلى الشبكة',
  createShop: 'أنشئوا متجراً',
  theSite: 'الموقع',
  portraitsLink: 'الصور',
  cooperatives: 'التعاونيات',
  blog: 'المدونة',
  marketplace: 'السوق',
  poweredBy: 'بدعم من',
  homeSeoTitle: 'سوق التعاونيات المغربية | شراء أونلاين | تعاونيتي',
  homeSeoDesc:
    'سوق التعاونيات المغربية: اطلبوا الحرف والسلال ومنتجات التراب أونلاين. التوصيل في كل المغرب والدفع عند الاستلام.',
  homeHeadline: 'سوق التعاونيات المغربية',
  homePitch:
    'شراء أونلاين من التعاونيات — سلة، توصيل في المغرب، دفع عند الاستلام. ليس مجرد مراسلة واتساب.',
  homeWhyTitle: 'لماذا تعاونيتي',
  homeWhyBuy: 'طلب أونلاين',
  homeWhyShip: 'توصيل في كل المغرب',
  homeWhyPay: 'الدفع عند الاستلام',
  homeFaqTitle: 'أسئلة شائعة',
  homeFaq: [
    {
      q: 'ما هو سوق تعاونيات تعاونيتي؟',
      a: 'متجر إلكتروني: تتصفحون منتجات التعاونيات المغربية، تطلبون، وتدفعون عند الاستلام.',
    },
    {
      q: 'هل يمكن الطلب أونلاين وليس فقط عبر واتساب؟',
      a: 'نعم. تعاونيتي متجر: سلة، طلب، توصيل في كل المغرب والدفع عند الاستلام.',
    },
  ],
  savedSeoTitle: 'المحفوظات — سوق تعاونيتي',
  savedEmpty: 'لا توجد منتجات محفوظة حالياً.',
  browseProducts: 'تصفح المنتجات',
  allProducts: 'كل المنتجات',
  sort: 'ترتيب',
  sortNew: 'الأحدث',
  sortBest: 'الأكثر مبيعاً',
  sortPriceAsc: 'السعر تصاعدياً',
  sortPriceDesc: 'السعر تنازلياً',
  all: 'الكل',
  others: 'أخرى',
  emptyProducts: 'لا توجد منتجات هنا حالياً.',
  coopPrompt: 'تريدون التعرف على التعاونيات وراء هذه المنتجات؟',
  coopPromptLink: 'اكتشفوا شركاءنا →',
  categoryBlurb: (name) =>
    `منتجات ${name || ''} المصنوعة يدوياً من تعاونيات مغربية. التوصيل في كل المغرب.`,
  browseTitle: (name) => `${name} من التعاونيات المغربية | تعاونيتي`,
  dealsSeoTitle: 'عروض — سوق تعاونيتي',
  dealsSeoTitleCat: (name) => `عروض ${name} — تعاونيتي`,
  dealsSeoDesc: 'منتجات مخفّضة في سوق تعاونيتي. التوصيل في كل المغرب.',
  dealsSeoDescCat: (name) => `العروض الجارية في ${name} من تعاونيات مغربية.`,
  dealsBlurb: (name) => `العروض الجارية في ${name || ''}، من تعاونيات مغربية.`,
  dealsEmpty: 'لا توجد عروض هنا حالياً.',
  allDeals: 'كل العروض',
  notFound: 'المنتج غير موجود.',
  loading: 'جاري التحميل…',
  client: 'زبون',
  reviewsCount: (n) => `${n} تقييم`,
  deliveryEverywhere: 'التوصيل في كل المغرب',
  moreOptions: 'المزيد',
  contactOwner: (name) => `التواصل مع ${name}`,
  reportProduct: 'الإبلاغ عن المنتج',
  contactHint: 'اتركوا بياناتكم. فريق تعاونيتي سيتواصل معكم.',
  contactOrCall: 'أو اتصلوا بفريق تعاونيتي',
  messageLabel: 'الرسالة',
  sendMessage: 'إرسال',
  contactSent: 'تم إرسال الرسالة. شكراً.',
  reportHint: 'أخبرونا ما المشكلة في هذا المنتج.',
  reportSent: 'تم إرسال البلاغ. شكراً.',
  ticketFail: 'تعذر الإرسال. أعيدوا المحاولة.',
  qty: 'الكمية',
  minus: 'أقل',
  plus: 'أكثر',
  addToCart: 'أضف إلى السلة',
  buy: 'اشترِ',
  share: 'شارك',
  description: 'الوصف',
  descFallback: (title, brand) =>
    `${title} من ${brand} على سوق تعاونيتي. التوصيل في كل المغرب والدفع عند الاستلام.`,
  seoProductDesc: (title, brand) => `اشترِ ${title} من ${brand} على سوق تعاونيتي. التوصيل في كل المغرب.`,
  moreDetails: (name) => `المزيد عن ${name}`,
  alsoLike: 'قد يعجبكم أيضاً',
  shippingReturns: 'التوصيل والإرجاع',
  shippingReturnsText: 'التوصيل في كل المغرب. الدفع عند الاستلام. يمكنكم مراسلتنا للإرجاع أو الاستبدال.',
  coopOwnerBadge: 'تعاونية',
  coopOwnerFollow: 'متابعة',
  coopOwnerVisit: (name) => `زيارة متجر ${name}`,
  coopOwnerNew: 'جديد',
  coopShopProducts: 'المنتجات',
  coopShopSearch: (name) => `ابحث في ${name}…`,
  coopShopSort: 'ترتيب',
  coopShopOnSale: 'العروض',
  coopShopPrice: 'السعر',
  coopShopInStock: 'متوفر',
  coopShopFollow: 'متابعة',
  coopShopFollowing: 'تتم المتابعة',
  coopShopFollowNeedAccount: 'أنشئوا حساباً لمتابعة هذا المتجر.',
  coopShopFilters: 'تصفية',
  coopShopReset: 'إعادة ضبط',
  coopShopDone: 'تم',
  coopShopMenu: 'القائمة',
  coopShopPortrait: 'القصة',
  coopShopPriceAny: 'كل الأسعار',
  coopShopPriceLow: 'أقل من 100 درهم',
  coopShopPriceMid: '100 – 250 درهم',
  coopShopPriceHigh: 'أكثر من 250 درهم',
  coopShopSeoDesc: (name) =>
    `اشترِ منتجات ${name}، تعاونية مغربية، عبر الإنترنت. التوصيل في كل المغرب والدفع عند الاستلام.`,
  coopShopMissing: 'هذه التعاونية ليس لها متجر هنا بعد.',
  coopCardReviews: 'التقييمات',
  coopCardRatings: (n) => `${n} تقييم`,
  coopCardContact: 'التواصل',
  coopCardCertificates: 'الشهادات',
  coopCardReport: 'الإبلاغ عن التعاونية',
  coopCardReportHint: 'قولوا لنا ما الذي لا يناسبكم في هذه التعاونية.',
  coopCardNoReviews: 'لا توجد تقييمات بعد.',
  coopCardNoContact: 'لا توجد معلومات تواصل.',
  coopCardNoCerts: 'لا توجد شهادات.',
  coopCardAddress: 'العنوان',
  coopCardWhatsapp: 'واتساب',
  coopCardVisit: 'زيارة الكتالوج',
  coopCardCopied: 'تم النسخ',
  coopCardInstagram: 'إنستغرام',
  coopCardFacebook: 'فيسبوك',
  noReviews: 'لا توجد تقييمات بعد.',
  prevReview: 'التقييم السابق',
  nextReview: 'التقييم التالي',
  prevPhoto: 'الوسائط السابقة',
  nextPhoto: 'الوسائط التالية',
  galleryPhoto: 'صورة',
  galleryVideo: 'فيديو',
  cartSeoTitle: 'السلة — سوق تعاونيتي',
  cartSeoDesc: 'سلتكم في سوق تعاونيتي.',
  articles: (n) => `${n} قطعة`,
  emptyCart: 'سلتكم فارغة.',
  remove: 'إزالة',
  summary: 'الملخص',
  subtotal: 'المجموع الفرعي',
  delivery: 'التوصيل',
  toConfirm: 'يُؤكد لاحقاً',
  deliveryFree: 'مجاني',
  total: 'المجموع',
  trustLine: 'التوصيل في كل المغرب · الدفع عند الاستلام',
  name: 'الاسم',
  phone: 'الهاتف',
  city: 'المدينة',
  cityPlaceholder: 'مثال: الدار البيضاء',
  address: 'العنوان',
  addressPlaceholder: 'الحي، الشارع، الرقم…',
  noteOptional: 'ملاحظة (اختياري)',
  locate: 'تحديد موقعي',
  locating: 'جاري البحث…',
  locateHint: 'يملأ المدينة والعنوان تلقائياً.',
  sending: 'جاري الإرسال…',
  order: 'اطلب',
  locNoGeo: 'المتصفح لا يستطيع تحديد الموقع. املأوا المدينة والعنوان يدوياً.',
  locFail: 'تعذر إيجاد العنوان. املأوا المدينة والعنوان يدوياً.',
  locDenied: 'تم رفض الموقع. املأوا المدينة والعنوان يدوياً.',
  orderFail: 'تعذر إرسال الطلب. تحققوا من المعلومات وحاولوا مرة أخرى.',
  orderDoneSeo: 'تم إرسال الطلب — تعاونيتي',
  orderDoneTitle: 'تم تسجيل طلبكم!',
  orderDoneText: (name) =>
    `شكراً${name ? ` ${name}` : ''}. سنتصل بكم لتأكيد التوصيل والدفع عند الاستلام.`,
  viewReceipt: 'عرض الوصل',
  back: 'رجوع',
  yourSpace: 'مساحتكم',
  accountLead: 'سجّلوا الدخول لرؤية الطلبات والوصولات والمجموعات.',
  accountLeadFollow: 'أنشئوا حساباً لمتابعة هذه التعاونية. ستصلكم رسالة عند كل منتج جديد.',
  createAccount: 'إنشاء حساب',
  email: 'البريد',
  password: 'كلمة المرور',
  createMyAccount: 'إنشاء حسابي',
  loginAction: 'دخول',
  loginFail: 'تعذر تسجيل الدخول.',
  hello: 'مرحباً',
  logout: 'خروج',
  overview: 'نظرة عامة',
  followed: 'المتابَعات',
  noFollowed: 'لا توجد متاجر متابعة حالياً.',
  orders: 'الطلبات',
  receipts: 'الوصولات',
  collections: 'المجموعات',
  noOrders: 'لا توجد طلبات حالياً.',
  noReceipts: 'لا توجد وصولات حالياً.',
  noSaved: 'لا توجد منتجات محفوظة.',
  viewReceiptLink: 'عرض الوصل',
  receiptLabel: (ref) => `وصل ${ref}`,
  accountSeoLogin: 'دخول — سوق تعاونيتي',
  accountSeoMe: 'مساحتي — سوق تعاونيتي',
  reviewed: 'ترك تقييماً',
  ordered: 'اشترى',
  close: 'إغلاق',
  addCollection: '+ إضافة مجموعة',
  collectionName: 'اسم المجموعة',
  create: 'إنشاء',
  collectionCreated: 'تم إنشاء المجموعة',
  collectionFail: 'تعذر إنشاء المجموعة.',
  switchLang: 'Passer en arabe',
  switchLangAr: 'التحويل إلى الفرنسية',
  langLabel: 'العربية',
  langLabelFr: 'Français',
  dateLocale: 'ar-MA',
};

const en = {
  ...fr,
  home: 'Home',
  browse: 'Browse',
  cart: 'Cart',
  deals: 'Deals',
  saved: 'Saved',
  account: 'Account',
  signIn: 'Sign in',
  logoAria: 'Taaouniaty Marketplace',
  searchPlaceholder: 'What are you looking for today?',
  searchAria: 'Search the marketplace',
  homeSearchPlaceholder: 'Cooperative, category or product…',
  homeSearchAria: 'Search a cooperative, category or product',
  kindCategory: 'Category',
  kindCoop: 'Cooperative',
  kindProduct: 'Product',
  ticker: 'Delivery across Morocco  ·  Cash on delivery  ·  Authentic products from Moroccan cooperatives  ·  ',
  featured: 'Featured',
  soldOut: 'Sold out',
  soldOutCart: 'A product in your cart is sold out. Remove it to place the order.',
  freeDelivery: 'Free delivery',
  save: 'Save',
  unsave: 'Remove from saved',
  savedLabel: 'Saved',
  percentOff: (n) => `${n}% off`,
  prevAria: (title) => `Previous: ${title}`,
  nextAria: (title) => `See more: ${title}`,
  ofTheMoment: 'Deal of the moment',
  featuredRail: 'Featured',
  followedRail: 'Your cooperatives',
  followToastTitle: (name) => `You follow ${name}`,
  followToastTitleGeneric: 'Shop followed',
  followToastText: 'You will get an email whenever it adds a new product.',
  atCoop: (name) => `From ${name}`,
  spotlightStory: (title, coop) => `Behind ${title}, the craft of ${coop}.`,
  networkKicker: 'The Taaouniaty network',
  networkTitle: 'Faces and stories',
  networkTitleAccent: ' from the Taaouniaty network.',
  networkText:
    'Meet the women and men of Taaouniaty’s cooperatives. Every workshop has a story. Buying here supports them directly, across Morocco.',
  networkCta: 'Discover the cooperatives',
  portraits: 'Portraits',
  ateliers: 'Workshops',
  together: 'Together',
  footLine1: 'The marketplace of the Taaouniaty network.',
  footLine2: 'Real cooperatives, across Morocco.',
  qrTitle: 'Scan to open the marketplace',
  discover: 'Discover',
  sell: 'Sell',
  social: 'Social',
  joinNetwork: 'Join the network',
  createShop: 'Create a shop',
  theSite: 'The site',
  portraitsLink: 'Portraits',
  cooperatives: 'Cooperatives',
  blog: 'Blog',
  poweredBy: 'Powered by',
  homeSeoTitle: 'Moroccan cooperatives marketplace | Shop online | Taaouniaty',
  homeSeoDesc:
    'Marketplace of Moroccan cooperatives: order crafts, gift boxes and terroir products online. Delivery across Morocco, cash on delivery.',
  homeHeadline: 'Moroccan cooperatives marketplace',
  homePitch:
    'Shop online from cooperatives — cart, delivery in Morocco, cash on delivery. Not just a WhatsApp contact.',
  homeWhyTitle: 'Why Taaouniaty',
  homeWhyBuy: 'Order online',
  homeWhyShip: 'Delivery across Morocco',
  homeWhyPay: 'Cash on delivery',
  homeFaqTitle: 'Common questions',
  homeFaq: [
    {
      q: 'What is the Taaouniaty cooperatives marketplace?',
      a: 'An online shop: browse products from Moroccan cooperatives, order, and pay on delivery.',
    },
    {
      q: 'Can I order online, not only via WhatsApp?',
      a: 'Yes. Taaouniaty is a shop: cart, checkout, delivery across Morocco, and cash on delivery.',
    },
  ],
  savedSeoTitle: 'Saved — taaouniaty marketplace',
  savedEmpty: 'No saved products yet.',
  browseProducts: 'Browse products',
  allProducts: 'All products',
  sort: 'Sort',
  sortNew: 'Newest',
  sortBest: 'Best selling',
  sortPriceAsc: 'Price: low to high',
  sortPriceDesc: 'Price: high to low',
  all: 'All',
  others: 'Others',
  emptyProducts: 'No products here yet.',
  coopPrompt: 'Want to meet the cooperatives behind these products?',
  coopPromptLink: 'Discover our partner cooperatives →',
  categoryBlurb: (name) =>
    `Our ${String(name || '').toLowerCase()}, handmade by Moroccan cooperatives. Delivery across Morocco.`,
  browseTitle: (name) => `${name} from Moroccan cooperatives | Buy online | Taaouniaty`,
  dealsSeoTitle: 'Deals — taaouniaty marketplace',
  dealsSeoTitleCat: (name) => `${name} deals — taaouniaty`,
  dealsSeoDesc: 'Products on promotion on the taaouniaty marketplace. Delivery across Morocco.',
  dealsSeoDescCat: (name) => `Current deals in ${name}, from Moroccan cooperatives.`,
  dealsBlurb: (name) =>
    `Current deals in ${String(name || '').toLowerCase()}, made by Moroccan cooperatives.`,
  dealsEmpty: 'No deals here right now.',
  allDeals: 'All deals',
  notFound: 'Product not found.',
  loading: 'Loading…',
  client: 'Customer',
  reviewsCount: (n) => `${n} reviews`,
  deliveryEverywhere: 'Delivery across Morocco',
  moreOptions: 'More options',
  contactOwner: (name) => `Contact ${name}`,
  reportProduct: 'Report product',
  contactHint: 'Leave your details. The taaouniaty team will get back to you.',
  contactOrCall: 'Or call the taaouniaty team',
  messageLabel: 'Message',
  sendMessage: 'Send',
  contactSent: 'Message sent. Thank you.',
  reportHint: 'Tell us what is wrong with this product.',
  reportSent: 'Report sent. Thank you.',
  ticketFail: 'Could not send. Please try again.',
  qty: 'Quantity',
  minus: 'Less',
  plus: 'More',
  addToCart: 'Add to cart',
  buy: 'Buy',
  share: 'Share',
  description: 'Description',
  descFallback: (title, brand) =>
    `${title} is offered by ${brand} on the taaouniaty marketplace. Delivery across Morocco, cash on delivery.`,
  seoProductDesc: (title, brand) =>
    `Buy ${title} from ${brand} on the taaouniaty marketplace. Delivery across Morocco.`,
  moreDetails: (name) => `More details from ${name}`,
  alsoLike: 'You may also like',
  shippingReturns: 'Delivery and returns',
  shippingReturnsText:
    'Delivery across Morocco. Cash on delivery. Write to us for a return or exchange.',
  coopOwnerBadge: 'Cooperative',
  coopOwnerFollow: 'Follow',
  coopOwnerVisit: (name) => `Visit ${name} shop`,
  coopOwnerNew: 'New',
  coopShopProducts: 'Products',
  coopShopSearch: (name) => `Search ${name}…`,
  coopShopSort: 'Sort by',
  coopShopOnSale: 'On sale',
  coopShopPrice: 'Price',
  coopShopInStock: 'In stock',
  coopShopFollow: 'Follow',
  coopShopFollowing: 'Following',
  coopShopFollowNeedAccount: 'Create an account to follow this shop.',
  coopShopFilters: 'Filters',
  coopShopReset: 'Reset',
  coopShopDone: 'Done',
  coopShopMenu: 'Menu',
  coopShopPortrait: 'Story',
  coopShopPriceAny: 'All prices',
  coopShopPriceLow: 'Under 100 MAD',
  coopShopPriceMid: '100 – 250 MAD',
  coopShopPriceHigh: 'Over 250 MAD',
  coopShopSeoDesc: (name) =>
    `Shop ${name} products online from a Moroccan cooperative. Delivery across Morocco, cash on delivery.`,
  coopShopMissing: 'This cooperative has no shop here yet.',
  coopCardReviews: 'Reviews',
  coopCardRatings: (n) => (n === 1 ? `${n} rating` : `${n} ratings`),
  coopCardContact: 'Contact',
  coopCardCertificates: 'Certificates',
  coopCardReport: 'Report store',
  coopCardReportHint: 'Tell us what is wrong with this cooperative.',
  coopCardNoReviews: 'No reviews yet.',
  coopCardNoContact: 'No contact details published.',
  coopCardNoCerts: 'No certificates published.',
  coopCardAddress: 'Address',
  coopCardWhatsapp: 'WhatsApp',
  coopCardVisit: 'Visit catalogue',
  coopCardCopied: 'Copied',
  coopCardInstagram: 'Instagram',
  coopCardFacebook: 'Facebook',
  noReviews: 'No reviews published yet.',
  prevReview: 'Previous review',
  nextReview: 'Next review',
  prevPhoto: 'Previous media',
  nextPhoto: 'Next media',
  galleryPhoto: 'Photo',
  galleryVideo: 'Video',
  cartSeoTitle: 'Cart — taaouniaty marketplace',
  cartSeoDesc: 'Your cart on the taaouniaty marketplace.',
  articles: (n) => (n > 1 ? `${n} items` : `${n} item`),
  emptyCart: 'Your cart is empty.',
  remove: 'Remove',
  summary: 'Summary',
  subtotal: 'Subtotal',
  delivery: 'Delivery',
  toConfirm: 'To confirm',
  deliveryFree: 'Free',
  total: 'Total',
  trustLine: 'Delivery across Morocco · Cash on delivery',
  name: 'Name',
  phone: 'Phone',
  city: 'City',
  cityPlaceholder: 'e.g. Casablanca',
  address: 'Address',
  addressPlaceholder: 'Neighborhood, street, no.…',
  noteOptional: 'Note (optional)',
  locate: 'Use my location',
  locating: 'Searching…',
  locateHint: 'Fills city and address automatically.',
  sending: 'Sending…',
  order: 'Place order',
  locNoGeo: 'Your browser cannot share location. Fill city and address yourself.',
  locFail: 'Could not find the address. Fill city and address yourself.',
  locDenied: 'Location denied. Fill city and address yourself.',
  orderFail: 'The order could not be sent. Check your details and try again.',
  orderDoneSeo: 'Order sent — taaouniaty',
  orderDoneTitle: 'Your order has been saved!',
  orderDoneText: (name) =>
    `Thank you${name ? `, ${name}` : ''}. We will call you to confirm delivery and cash on delivery.`,
  viewReceipt: 'View receipt',
  back: 'Back',
  yourSpace: 'Your space',
  accountLead: 'Sign in to see your orders, receipts and collections.',
  accountLeadFollow: 'Create an account to follow this cooperative. You will get an email whenever it adds a new product.',
  createAccount: 'Create an account',
  email: 'Email',
  password: 'Password',
  createMyAccount: 'Create my account',
  loginAction: 'Sign in',
  loginFail: 'Could not sign in.',
  hello: 'Hello',
  logout: 'Log out',
  overview: 'Overview',
  followed: 'Following',
  noFollowed: 'No shops followed yet.',
  orders: 'Orders',
  receipts: 'Receipts',
  collections: 'Collections',
  noOrders: 'No orders yet.',
  noReceipts: 'No receipts yet.',
  noSaved: 'No saved products.',
  viewReceiptLink: 'View receipt',
  receiptLabel: (ref) => `Receipt ${ref}`,
  accountSeoLogin: 'Sign in — taaouniaty marketplace',
  accountSeoMe: 'My space — taaouniaty marketplace',
  reviewed: 'left a review',
  ordered: 'bought',
  close: 'Close',
  addCollection: '+ Add a collection',
  collectionName: 'Collection name',
  create: 'Create',
  collectionCreated: 'Collection created',
  collectionFail: 'Could not create the collection.',
  switchLang: 'Switch to Arabic',
  switchLangAr: 'Switch to French',
  langLabel: 'العربية',
  langLabelFr: 'Français',
  dateLocale: 'en-GB',
};

export const SHOP_COPY = { fr, ar, en };

const SEO_KEYS = new Set([
  'homeSeoTitle',
  'homeSeoDesc',
  'savedSeoTitle',
  'browseTitle',
  'dealsSeoTitle',
  'dealsSeoTitleCat',
  'dealsSeoDesc',
  'dealsSeoDescCat',
  'cartSeoTitle',
  'cartSeoDesc',
  'orderDoneSeo',
  'accountSeoLogin',
  'accountSeoMe',
  'coopShopSeoDesc',
  'seoProductDesc',
  'logoAria',
  'searchAria',
  'homeSearchAria',
  'prevAria',
  'nextAria',
  'prevReview',
  'nextReview',
  'prevPhoto',
  'nextPhoto',
  'galleryPhoto',
  'galleryVideo',
  'dateLocale',
  'switchLang',
  'switchLangAr',
  'langLabel',
  'langLabelFr',
]);

const INLINE_KEYS = new Set([
  'ticker',
  'searchPlaceholder',
  'homeSearchPlaceholder',
  'coopShopSearch',
  'collectionName',
  'cityPlaceholder',
  'addressPlaceholder',
  'sortNew',
  'sortBest',
  'sortPriceAsc',
  'sortPriceDesc',
]);

function joinPair(french, arabic, stack) {
  if (arabic == null || arabic === '' || arabic === french) return french;
  return stack ? `${french}\n${arabic}` : `${french} · ${arabic}`;
}

export function ShopBi({ children, className = '' }) {
  const raw = children == null ? '' : String(children);
  let french = raw;
  let arabic = '';
  const newline = raw.indexOf('\n');
  if (newline !== -1) {
    french = raw.slice(0, newline);
    arabic = raw.slice(newline + 1);
  } else {
    const mid = raw.indexOf(' · ');
    if (mid !== -1) {
      french = raw.slice(0, mid);
      arabic = raw.slice(mid + 3);
    }
  }
  if (!arabic || arabic === french) {
    return className ? createElement('span', { className }, french) : french;
  }
  return createElement(
    'span',
    { className: ['shop-bi', className].filter(Boolean).join(' ') },
    createElement('span', { className: 'shop-bi__fr' }, french),
    createElement('span', { className: 'shop-bi__ar' }, arabic)
  );
}

export function shopCopy(language) {
  if (language === 'ar') return ar;
  if (language === 'en') return en;
  return fr;
}

export function bilingualShopCopy() {
  const out = {};
  Object.keys(fr).forEach((key) => {
    if (SEO_KEYS.has(key)) {
      out[key] = fr[key];
      return;
    }
    const french = fr[key];
    const arabic = ar[key];
    const stack = !INLINE_KEYS.has(key);
    if (typeof french === 'function') {
      out[key] = (...args) =>
        joinPair(french(...args), typeof arabic === 'function' ? arabic(...args) : arabic, stack);
      return;
    }
    if (Array.isArray(french) && Array.isArray(arabic)) {
      out[key] = french.map((item, index) => {
        const other = arabic[index];
        if (item && typeof item === 'object' && 'q' in item) {
          return {
            q: joinPair(item.q, other?.q, true),
            a: joinPair(item.a, other?.a, true),
          };
        }
        return item;
      });
      return;
    }
    out[key] = joinPair(french, arabic, stack);
  });
  return out;
}

export const ShopI18nContext = createContext({
  language: 'fr',
  setLanguage: () => {},
  t: fr,
  isAr: false,
});

function toBiValue(value) {
  if (typeof value === 'function') {
    return (...args) => {
      const out = value(...args);
      return typeof out === 'string' ? createElement(ShopBi, null, out) : out;
    };
  }
  if (typeof value === 'string') return createElement(ShopBi, null, value);
  return value;
}

export function useShopI18n() {
  const ctx = useContext(ShopI18nContext);
  const raw = ctx.t;
  const t = useMemo(
    () =>
      new Proxy(raw, {
        get(target, prop) {
          if (typeof prop !== 'string') return target[prop];
          if (prop === 'homeFaq' && Array.isArray(target.homeFaq)) {
            return target.homeFaq.map((item) => ({
              q: createElement(ShopBi, null, item.q),
              a: createElement(ShopBi, null, item.a),
            }));
          }
          return toBiValue(target[prop]);
        },
      }),
    [raw]
  );
  return { ...ctx, t, raw };
}
